import React, { useState, useEffect } from "react";
import DropDownField from "../../Shared/DropdownField";
import { DisplayMsg } from "../../services/toastService";
import { setUrl } from "../../handlers";

const Preference = (props) => {
  const [Preference, setPreference] = useState({
    COMMENTS: "",
    ASSIGNEE: "",
    TEAM: "",
    STATUS: "",
  });

  const Preferences = [
    {
      label: "Inbox",
      value: "I",
    },
    {
      label: "Email",
      value: "E",
    },
    {
      label: "Both",
      value: "B",
    },
  ];

  const PreferencePopup = () => {
    props.parentCallback(false);
  };

  useEffect(() => {
    LoadUserPreference();
  }, []);
  const LoadUserPreference = async () => {
    const userseqNum = sessionStorage.SEQ_NUM;
    const formData = new FormData();
    formData.append("USERSEQNUM", userseqNum);

    const result = await fetch(setUrl("HOME", "LOADUSERPREFRENCES", true), {
      method: "POST",
      body: formData,
    });
    const response = await result.json();
    if (response.status) {
      const preferenceInfo = JSON.parse(response.userPData);
      for (const item in preferenceInfo) {
        const preferenceType = preferenceInfo[item].TYPE;
        const preferenceValue = preferenceInfo[item].NOTIFICATION_TYPE;
        setPreference((prevData) => ({
          ...prevData,
          [preferenceType]: preferenceValue,
        }));
      }
    } else {
      DisplayMsg("2", "User Preference have not been loaded successfully.");
    }
  };

  const SavePreference = async () => {
    try {
      document.getElementById("loader").style.display = "block";
      const userseqNum = sessionStorage.SEQ_NUM;
      const userName = sessionStorage.USER;
      const formdata = new FormData();
      formdata.append("USERNAME", userName);
      formdata.append("USERSEQNUM", userseqNum);
      formdata.append("COMMENTS_NOTITYPE", Preference.COMMENTS);
      formdata.append(
        "COMMENTS_NOTITYPE_SEQ_NUM",
        sessionStorage.CNT_SEQ_NUM ? sessionStorage.CNT_SEQ_NUM : ""
      );
      formdata.append("ASSIGNEE_NOTITYPE", Preference.ASSIGNEE);
      formdata.append(
        "ASSIGNEE_NOTITYPE_SEQ_NUM",
        sessionStorage.ANT_SEQ_NUM ? sessionStorage.ANT_SEQ_NUM : ""
      );
      formdata.append("TEAM_NOTITYPE", Preference.TEAM);
      formdata.append(
        "TEAM_NOTITYPE_SEQ_NUM",
        sessionStorage.TNT_SEQ_NUM ? sessionStorage.TNT_SEQ_NUM : ""
      );
      formdata.append("STATUS_NOTITYPE", Preference.STATUS);
      formdata.append(
        "STATUS_NOTITYPE_SEQ_NUM",
        sessionStorage.S_SEQ_NUM ? sessionStorage.S_SEQ_NUM : ""
      );

      const result = await fetch(
        setUrl("DASHBOARD", "ADD_USER_PREFERENCES", true),
        {
          method: "POST",
          body: formdata,
        }
      );
      const response = await result.json();
      if (response.status) {
        DisplayMsg("1", response.Message);
      } else {
        DisplayMsg("2", response.Message);
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const FieldData = (textField) => {
    setPreference((prevData) => ({
      ...prevData,
      [textField.fieldName]: textField.fieldValue,
    }));
  };

  const FieldValue = (fieldName) => {
    const fieldValue = Preference[fieldName] != null ? Preference[fieldName] : "";
    return fieldValue;
  };

  return (
    <>
      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />
      <div className="overlay">
        <div className="popup change-password">
          <div className="popup__header">
            <h3>User Preference</h3>
            <span
              className="close"
              role="button"
              onClick={() => PreferencePopup(false)}
            >
              ×
            </span>
          </div>
          <div className="content">
            <div className="popup__body">
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <DropDownField
                    id="COMMENTS"
                    classDiv
                    bold
                    label="Comments:"
                    required={false}
                    options={Preferences}
                    value={FieldValue("COMMENTS")}
                    ReceivedTextData={FieldData}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <DropDownField
                    id="ASSIGNEE"
                    classDiv
                    bold
                    label="Assignee:"
                    required={false}
                    options={Preferences}
                    value={FieldValue("ASSIGNEE")}
                    ReceivedTextData={FieldData}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <DropDownField
                    id="TEAM"
                    classDiv
                    bold
                    label="Team:"
                    required={false}
                    options={Preferences}
                    value={FieldValue("TEAM")}
                    ReceivedTextData={FieldData}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <DropDownField
                    id="STATUS"
                    classDiv
                    bold
                    label="Status:"
                    required={false}
                    options={Preferences}
                    value={FieldValue("STATUS")}
                    ReceivedTextData={FieldData}
                  />
                </div>
              </div>
              <div className="row text-center">
                <div className="col-md-12 col-sm-12">
                  <label>&nbsp;</label>
                  <input
                    type="button"
                    className="btnLinkBlue"
                    value="Save"
                    onClick={() => SavePreference()}
                  />
                  <input
                    type="button"
                    className="btnCancel ClosePopup"
                    value="Cancel"
                    onClick={() => PreferencePopup()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Preference;
